import { z } from 'zod';
import { VehicleTechnology } from '../fleet/vehicle.schemas.js';
/**
 * Kaizen 15–17 — técnicos de manutenção e inspetores: especialidade,
 * tecnologias em que atuam e nível de experiência (1, 2 ou 3). O critério
 * de classificação é da Manutenção; o sistema só registra e usa.
 */
export const TECHNICIAN_LEVELS = [1, 2, 3];
export const TECHNICIAN_LEVEL_LABELS = {
    1: 'Nível 1 — iniciante',
    2: 'Nível 2 — pleno',
    3: 'Nível 3 — sênior',
};
export const createTechnicianSchema = z.object({
    registration: z.string().trim().min(1, 'Informe a matrícula').max(32),
    name: z.string().trim().min(3, 'Informe o nome').max(120),
    specialtyId: z.string().uuid('Selecione a especialidade'),
    technologies: z.array(z.nativeEnum(VehicleTechnology)).min(1, 'Marque ao menos uma tecnologia'),
    level: z.coerce.number().int().min(1).max(3).default(1),
    isInspector: z.boolean().default(false),
    /** Conta do sistema, quando o técnico também opera as telas. */
    userId: z.string().uuid().optional(),
});
export const updateTechnicianSchema = createTechnicianSchema.partial().extend({
    isActive: z.boolean().optional(),
});
/** Kaizen — matriz de treinamentos: o que cada técnico fez e o que vence. */
export const TRAINING_KINDS = {
    PLANO_MANUTENCAO: 'Plano de manutenção (IT.MAN)',
    ALTA_TENSAO: 'Alta tensão / eBUS (NR-10 + fabricante)',
    NR: 'Norma regulamentadora (NR-12, NR-35…)',
    PROCEDIMENTO: 'POP / procedimento interno',
    OUTRO: 'Outro',
};
export const createTrainingSchema = z.object({
    kind: z.enum(Object.keys(TRAINING_KINDS)),
    title: z.string().trim().min(3, 'Informe o treinamento').max(120),
    completedAt: z.coerce.date({ message: 'Informe a data' }),
    validUntil: z.preprocess((v) => (v === '' || v === null || v === undefined ? undefined : v), z.coerce.date().optional()),
    hours: z.preprocess((v) => (v === '' || v === null || v === undefined ? undefined : v), z.coerce.number().int().min(0).optional()),
    note: z.string().trim().max(255).optional(),
});
//# sourceMappingURL=technician.schemas.js.map